import Input from '../../../ui/input';
import Text from '../../../ui/text';
import RadioGroup from '../../../ui/radio-group';
import { useFormContext } from 'react-hook-form';
import { PCPPatientOptions } from '../constants';

function PCPInformation() {
  const { 
    register,
    control,
    watch,
    formState: { errors },
  } = useFormContext();
  const watchPCPPatient = watch('PCPPatient');
  return (
    <section className="w-full">
      <h2 className="text-2xl font-semibold text-secondary">
        <Text>Your PCP Information</Text>
      </h2>
      <div className="grid grid-cols-12 gap-5 mt-5">
        <div className='col-span-12 sm:col-span-6 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='primaryCarePhysician'>Name of your Primary Care Physician (PCP)</Text>
          <Input
            {...register('primaryCarePhysician')}
            size='sm'
            label={<Text>Name of your Primary Care Physician (PCP)</Text>}
            placeholder="-"
            errorMessage={errors?.primaryCarePhysician?.message || null}
            isInvalid={errors?.primaryCarePhysician ? true : false}
          />
        </div>
        <div className='col-span-12 sm:col-span-6 flex flex-col justify-end items-start'>
          <Text type='label' htmlFor='pcpID'>PCP ID (Please include all digits)</Text>
          <Input
            {...register('pcpID')}
            size='sm'
            label={<Text>PCP ID (Please include all digits)</Text>}
            placeholder="-"
            errorMessage={errors?.pcpID?.message || null}
            isInvalid={errors?.pcpID ? true : false}
          />
        </div>
        <div className='col-span-12 sm:col-span-6 flex flex-col justify-end items-start'>
          <Text type='label' htmlFor='clinicName'>Name of Clinic or Health Center</Text>
          <Input
            {...register('clinicName')}
            size='sm'
            label={<Text>Name of Clinic or Health Center</Text>}
            placeholder="-"
            errorMessage={errors?.clinicName?.message || null}
            isInvalid={errors?.clinicName ? true : false}
          />
        </div>
        <div className='col-span-12 sm:col-span-6 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='PCPPatient'>Are you already a patient of this PCP you chose?</Text>
          <div className='mt-2 sm:mt-0 w-full flex-1 flex flex-col items-start sm:flex-row sm:justify-start sm:items-center gap-3'>
            <div className=''>
              <RadioGroup
                control={control}
                name='PCPPatient'
                size='sm'
                options={PCPPatientOptions} 
                isInvalid={!!errors?.PCPPatient}
                errorMessage={errors?.PCPPatient?.message || null}
              />
            </div>
            {watchPCPPatient === 'other' && (<div className='w-full sm:w-auto min-w-[150px]'>
              <Input
                {...register('PCPPatientOther')}
                size='sm'
                label=''
                placeholder="-"
                errorMessage={errors?.PCPPatientOther?.message || null}
                isInvalid={errors?.PCPPatientOther ? true : false}
              />
            </div>)}
          </div>
        </div>
      </div>
    </section>
  );
}

export default PCPInformation;